import { alphaColor } from "../../../utils/colors";
export default theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexFlow: 'column nowrap',
    minHeight: 212,
    gap: 12,
    padding: 16,
    backgroundColor: theme.colors.primary.white,
    borderRadius: 8,
    boxShadow: '0 1px 3px 0 rgba(39, 60, 80, 0.2), 0 2px 2px 0 rgba(39, 60, 80, 0.12), 0 0 2px 0 rgba(39, 60, 80, 0.14)',
    overflow: 'hidden',
    '&, & *': {
      boxSizing: 'border-box'
    },
    '&:hover $hoverContent': {
      opacity: 1
    }
  },
  header: {
    display: 'flex',
    flexFlow: 'row nowrap',
    gap: 8,
    alignItems: 'center'
  },
  icon: {
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.background.jadeT7,
    borderRadius: '50%',
    '& > *': {
      width: '24px !important',
      height: '24px !important'
    }
  },
  badge: {
    display: 'inline-flex',
    marginLeft: 'auto',
    minWidth: 'auto',
    height: 24,
    lineHeight: 1,
    padding: '4px 8px',
    flexShrink: 0
  },
  main: {
    display: 'flex',
    flexFlow: 'row nowrap',
    gap: 24,
    padding: '0 8px',
    alignItems: 'center'
  },
  content: {
    display: 'flex',
    flexFlow: 'column nowrap',
    gap: 12,
    alignItems: 'flex-start',
    flex: 1,
    height: '100%',
    '& > * + *, & > *:only-child': {
      margin: 'auto 0'
    }
  },
  price: {
    fontWeight: 400,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8
  },
  contentHeadline: {
    display: 'flex',
    flexFlow: 'row nowrap',
    gap: 6,
    alignItems: 'center'
  },
  figure: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    flex: '0 0 130px',
    margin: 0,
    '& > img, & > svg': {
      display: 'block',
      maxWidth: '100%'
    },
    '& figcaption': {
      textAlign: 'center'
    }
  },
  progress: {
    gridColumn: '1 / span 2'
  },
  percentage: {
    justifySelf: 'flex-end'
  },
  hoverContent: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: alphaColor(theme.colors.primary.white, 0.9),
    padding: '32px 24px',
    display: 'flex',
    flexFlow: 'column nowrap',
    gap: 4,
    justifyContent: 'center',
    opacity: 0,
    transition: 'opacity .5s ease'
  },
  hoverContentCTA: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-evenly',
    marginTop: 'auto'
  },
  hoverContentMarkdown: {
    gap: 4
  }
});